import { render, staticRenderFns } from "./wew-blue-break.vue?vue&type=template&id=ef2dc35e&"
var script = {}
import style0 from "./wew-blue-break.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "wew-blue-break.vue"
export default component.exports